module.exports = "https://jsak.mmtcdn.com/tripmoney/static/media/APOLLO SBI CARD.0a253fe7.png";